export const PROCEDURES = [
  { id: 'rhinoplasty', label: 'Rhinoplasty' },
  { id: 'chin_augmentation', label: 'Chin Augmentation' },
  { id: 'buccal_fat_removal', label: 'Buccal Fat Removal' },
  { id: 'facelift', label: 'Facelift' },
  { id: 'mini_facelift', label: 'Mini Facelift' },
  { id: 'deep_plane_facelift', label: 'Deep Plane Facelift' },
  { id: 'revision_facelift', label: 'Revision Facelift' },
  { id: 'brow_lift', label: 'Brow Lift' },
  { id: 'eyelid_surgery', label: 'Eyelid Surgery' },
  { id: 'neck_lift', label: 'Neck Lift' },
  { id: 'fue_hair_transplant', label: 'FUE Hair Transplant' },
  { id: 'chemical_peel', label: 'Chemical Peel' },
  { id: 'laser_skin_resurfacing', label: 'Laser Skin Resurfacing' },
  { id: 'pdo_thread_lift', label: 'PDO Thread Lift' },
  { id: 'silhouette_inst_lift', label: 'Silhouette InstaLift' },
];

export const DEFAULT_PROCEDURE_ID = PROCEDURES[0].id;
export const DEFAULT_INTENSITY = 50;
